import { lazyModulePage } from '@/soluqr/tiers/lazyModulePage';

export const assistantRouteElements = [
  {
    segment: 'assistant-training',
    element: lazyModulePage('assistant', () => import('@/soluqr/modules/assistant/screens/AssistantTrainingPage')),
  },
];
